import React, { Fragment } from "react"
import Price from "components/Price/Price";

import { Icon, Image,Message,Table }                      from "semantic-ui-react"
import { Link }                             from "react-router-dom"
import shop from "shop/shop"


const PositionRow = ( {position, product} ) => {
	const useProductData = product && product.extras
	return (
		<tr>
			<td>{position.article_nr}</td>
			<td><span className="f5">{position.desc}</span><br />
				{useProductData && <div className="f6 black-60"><span className="">{product.extras.Farbe},</span> <span
					className="black-60 d6 ">{product.extras.Groesse}</span></div>}
			</td>
			<td className="tl">{position.count} {translate( "PU" )} <br />
				<div className="black-60 d6 ">{position.count * position.unit_multi} {position.quantities && position.quantities[0] && position.quantities[0].des ? position.quantities[0].des : translate("Stück")} </div>
			</td>
			{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
      <td className="tr"><Price>{position.price * position.unit_multi}</Price></td>}
			{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
      <td className="tr">
				<div className="tr"><Price>{position.sum}</Price></div>
			</td>}
		</tr>
	)
}

const SuccessTable = ( {orderDiscount, isOffer, positions, netto, byId, showShipping, append = null, prepend = null} ) => {
	if(!showShipping) {
		showShipping = "0" 
	  }
	const tax = (Number( netto ) + parseFloat(showShipping.replace(",", "."))) / 100 * Number( shop.config.taxRate )
	const hasTax = shop.config.taxRate
  console.log("SUCCESSTABLE", shop.session, isOffer, positions, orderDiscount)

	return (<Fragment>
		<Table>
			<colgroup>
				<col width="10%" />
				<col width="45%" />
				<col width="15%" />
				{(!isOffer || (shop.session && shop.session.shopuser && !shop.session.shopuser.guest)) && <col width="15%" />}
				{(!isOffer || (shop.session && shop.session.shopuser && !shop.session.shopuser.guest)) && <col width="15%" />}
			</colgroup>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>{translate( "article" )}</Table.HeaderCell>
					<Table.HeaderCell>&nbsp;</Table.HeaderCell>
					<Table.HeaderCell className="tl">Anzahl</Table.HeaderCell>
					{(!isOffer || (shop.session && shop.session.shopuser && !shop.session.shopuser.guest)) && <Table.HeaderCell className="tr">{translate("Preis/VE")}</Table.HeaderCell>}
					{(!isOffer || (shop.session && shop.session.shopuser && !shop.session.shopuser.guest)) && <Table.HeaderCell className="tr">
						<div className="tr">Summe</div>
					</Table.HeaderCell>}
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{prepend && prepend}

				{positions.map( ( position ) => {
					const product = byId[position.article_id]
					return <PositionRow key={position.article_id} position={position} product={product} />
				} )}
				{isOffer &&
						<Table.Row>
							<Table.Cell colSpan={4} className=" tr">
								<div className="tr">{translate( "Versankosten" )}</div>
							</Table.Cell>
							<Table.Cell>
								<div className="pv3 f3 tr "><Price>{parseFloat(showShipping.replace(",", "."))}</Price></div>
							</Table.Cell>
						</Table.Row>
				}
				{(!isOffer && (shop.session && shop.session.shopuser && !shop.session.shopuser.guest)) &&
					<Fragment>
						<Table.Row>
							<Table.Cell colSpan={4} className=" tr">
								{orderDiscount != 0  && <Fragment>
									<div className="tr pv3">{translate("Zwischensumme")}</div>
									<div className="tr pv3">{translate("Sie sparen")}</div>
								</Fragment>}
								<div className={orderDiscount != 0 ? "tr pv3" : "tr"}>{translate("Gesamtsumme (Netto)*")}</div>
							</Table.Cell>
							<Table.Cell>
								{orderDiscount != 0  && <Fragment>
									<div className="pv3 f3 tr strike black-60"><Price>{Number(orderDiscount)}</Price></div>
									<div className="pv3 f3 tr "><Price>{Number(orderDiscount) - netto}</Price></div>
								</Fragment>}
								<div className={orderDiscount != 0 ? "pv3 f3 tr red" : "pv3 f3 tr"}><Price>{netto}</Price></div>
							</Table.Cell>
						</Table.Row>
						{<Table.Row>
							<Table.Cell colSpan={4} className=" tr">
								<div className="tr">{translate( "inkl. Versankosten" )}</div>
							</Table.Cell>
							<Table.Cell>
								<div className="pv3 f3 tr "><Price>{parseFloat(showShipping.replace(",", ".")) + Number(netto)}</Price></div>
							</Table.Cell>
						</Table.Row>}

						{hasTax && <Table.Row>
							<Table.Cell colSpan={4} className=" tr">
								<div className="tr">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</div>
							</Table.Cell>
							<Table.Cell>
								<div className="pv3 f3 tr "><Price>{tax}</Price></div>
							</Table.Cell>
						</Table.Row>}

						{hasTax &&<Table.Row>
							<Table.Cell colSpan={4} className=" tr">
								<div className="tr">{translate( "inkl. Steuern" )}</div>
							</Table.Cell>
							<Table.Cell>
								<div className="pv3 f3 tr "><Price>{tax + parseFloat(showShipping.replace(",", ".")) + Number(netto)}</Price></div>
							</Table.Cell>
						</Table.Row>}


						
						{append && append}
					</Fragment>
				}
			</Table.Body>
		</Table>
	</Fragment>)
}

export default SuccessTable


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/SuccessTable.js